<template>
  <div style="height: 100%;">
    <div class="item">
      <img :src="img" alt="" :class="['item-img', mode == 'right' ? 'item-img-r' : '']">
      <div :class="['info', mode == 'right' ? 'info-r' : '']">
        <div class="title">{{title}}</div>
        <p class="info-p" v-for="(item, index) in text" :key="index">{{item}}</p>
      </div>
      <!--箭头-->
      <div :class="['arrow', mode == 'right' ? 'arrow-r' : '']" @click="next" style="display:none;"></div>
    </div>
  </div>

</template>

<script type="text/ecmascript-6">
export default {
  props:{
    img: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: Array,
      default: []
    },
    mode: {
      type: String,
      default: 'left'
    },
    index:{
      type: null
    }
  },
  data() {
    return {

    }
  },
  methods: {
    next(){
      this.$emit('next', this.index)
    }
  },
  components: {
  }
}
</script>

<style scoped lang="scss">
@import "../../common/common.scss";
.item{
  width: 100%;
  min-width: $min-width;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  @include clearfix;
  .item-img{
    float: left;
    &.item-img-r{
      float: right;
    }

  }
  .info{
    float: right;
    width: 580px;
    position: absolute;
    top:0;
    right: 0;
    @media screen  and (min-width:$min-width) and (max-width: 1200px){
      padding-bottom: 80px;
      margin-right: 10px;
      &.info-r{
        left: 10px;
      }
    }
    &.info-r{
      right: auto;
      left: 10px;
    }
    .title{
      font-size: 36px;
      line-height: 1.0;
      color: #ff9238;
      margin-top: 32px;
      margin-bottom: 78px;

    }
    p{
      font-size: 18px;
      line-height: 30px;
      color: #999;
      margin-bottom: 16px;
    }
  }
  .arrow{
    position: absolute;
    bottom: 10px;
    right: 20px;
    width: 33px;
    height: 39px;
    padding: 20px;
    background-image: url('../../assets/images/arrow-down.png');
    @include bg-center;
    cursor: pointer;
    &:hover{
      background-color:rgba(230,230,230,.3);
    }
    &.arrow-r{
      left: 0;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/apps/zcx/components/business/IndexItem.vue